<script setup>
import { ref, watch } from 'vue';
import Switch from 'dashboard/components-next/switch/Switch.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  signature: {
    type: String,
    default: '',
  },
  enabled: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['updateSignature', 'updateEnabled']);

const value = ref(props.signature ?? '');
const isEnabled = ref(props.enabled);

watch(
  () => props.signature ?? '',
  newValue => {
    value.value = newValue;
  }
);
watch(
  () => props.enabled,
  newValue => {
    isEnabled.value = newValue;
  }
);

const save = () => {
  emit('updateSignature', (value.value || '').trim());
};

const toggle = newValue => {
  isEnabled.value = newValue;
  emit('updateEnabled', newValue);
};
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent="save()">
    <div
      class="flex items-center justify-between gap-4 p-3 rounded-lg border border-n-weak bg-n-solid-1"
    >
      <span class="text-sm font-medium text-n-slate-12">
        {{ $t('PROFILE_SETTINGS.FORM.WHATSAPP_SIGNATURE_SECTION.ENABLE_LABEL') }}
      </span>
      <Switch :model-value="isEnabled" @update:model-value="toggle" />
    </div>
    <textarea
      v-model="value"
      rows="2"
      :disabled="!isEnabled"
      class="w-full p-3 text-sm rounded-lg resize-none border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:ring-2 focus:ring-n-brand/40 disabled:opacity-50"
      :placeholder="
        $t('PROFILE_SETTINGS.FORM.WHATSAPP_SIGNATURE_SECTION.PLACEHOLDER')
      "
    />
    <div>
      <NextButton
        type="submit"
        :disabled="!isEnabled"
        :label="
          $t('PROFILE_SETTINGS.FORM.WHATSAPP_SIGNATURE_SECTION.BTN_TEXT')
        "
      />
    </div>
  </form>
</template>
